import { SingleService } from '../ProjectOptions/ProjectDetails/Costs/SingleService';
import { useTaskModal } from './context.taskModal';

export function TaskCosts() {
  const { task, project } = useTaskModal();

  const service = project.services.find(({ id }) => task.serviceConfigId === id);

  if (!service) return null;

  return <SingleService service={service} closable={false} />;
}
